import { apiCall } from "../../services/api-service";

export const getMilestoneStatusApi = async () => {
  try {
    const response = await apiCall("GET", "getMilestoneStatus");
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitMilestoneAPI = async (body) => {
  try {
    const response = await apiCall("POST", "milestone", body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateMilestoneAPI = async (id, body) => {
  try {
    const response = await apiCall("PUT", `milestone/${id}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getMilestoneEditApi = async (id) => {
  try {
    const response = await apiCall("GET", `milestone/get/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getMilestonesListApi = async (params) => {
  try {
    const response = await apiCall("GET", "milestone", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const deleteMilestoneApi = async (id) => {
  try {
    const response = await apiCall("DELETE", `milestone/delete/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
